export const select2DefaultOptionWithAllowClear = {
    placeholder: "",
    allowClear: true,
    minimumResultsForSearch: -1
}